import { render, staticRenderFns } from "./SupplyChainItemQuotaReport.vue?vue&type=template&id=0b78eb9d"
import script from "./SupplyChainItemQuotaReport.vue?vue&type=script&lang=js"
export * from "./SupplyChainItemQuotaReport.vue?vue&type=script&lang=js"
import style0 from "./SupplyChainItemQuotaReport.vue?vue&type=style&index=0&id=0b78eb9d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports